<template>
  <div class="page-content--bgf7">
    <section class="au-breadcrumb2">
      <div class="container m-b-60">
        <div class="row m-t-20 m-b-10">
          <div class="col-md-12 p-l-20">
            <h3 class="title-5">
              <i class="fas fa-play-circle p-r-5" />
              On Air
            </h3>
          </div>
        </div>
        <v-card>
          <!--div class="row">
            <div class="col-md-6">
              <video-player
                ref="videoPlayer"
                class="video-player-box"
                :options="playerOptions"
                :src="playerOptions.src"
                @ready="playerReadied"
              />
            </div>
          </div-->
          <div class="row p-l-10 p-r-10">
            <div
              class="col-md-7 col-sm-12"
              style="min-width: 740px; width: 740px;"
            >
              <iframe
                id="on_air"
                :src="frameSrc"
                height="380"
                width="740"
                frameborder="0"
              />
            </div>
            <div class="col-md-5 col-sm-12">
              <v-list-item
                v-if="currentEvent"
                three-line
              >
                <v-list-item-content>
                  <v-list-item-title>
                    On Now:
                  </v-list-item-title>
                  <v-list-item-title class="text-h5">
                    {{ currentEvent.program.name }}
                  </v-list-item-title>
                  <div class="text-overline">
                    {{ moment(currentEvent.start).format('MMM D, HH:mm:ss') }}
                  </div>
                  <v-list-item-subtitle>
                    {{ currentEvent.program.description }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <!--v-list-item-avatar
                  tile
                  height="90"
                  width="60">
                  <v-img :src="currentEvent.asset.poster + '?img.contain=80x120'"></v-img>
                </v-list-item-avatar-->
              </v-list-item>
              <v-list-item
                v-else
                hree-line
              >
                <v-list-item-content>
                  <v-list-item-title>
                    On Now:
                  </v-list-item-title>
                  <v-list-item-title
                    v-if="!loading"
                    class="text-h5"
                  >
                    N/A
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <div class="row">
                <div class="col-md-6 p-t-0">
                  <v-list-item
                    v-if="currentEvent"
                    two-line
                    align="center"
                  >
                    <v-list-item-content>
                      <v-list-item-subtitle>Played Time</v-list-item-subtitle>
                      <v-list-item-title class="text-h5 primary--text">
                        {{ played }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
                <div class="col-md-6 text-h3 p-t-0">
                  <v-list-item
                    v-if="currentEvent"
                    two-line
                    align="center"
                  >
                    <v-list-item-content>
                      <v-list-item-subtitle>Remaining Time</v-list-item-subtitle>
                      <v-list-item-title class="text-h5 deep-orange--text">
                        {{ remaining }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
                <div
                  class="col-md-12 p-t-0 m-t-0 p-l-0"
                  style="padding-right: 28px; padding-left: 12px;"
                >
                  <v-progress-linear
                    v-if="currentEvent"
                    :value="playedProgress"
                    color="blue lighten-2"
                    class="ma-0 pa-0"
                    height="5"
                  />
                </div>
              </div>
              <div class="col-md-12 m-t-10 ml-0 pl-0">
                <v-list-item-title
                  v-if="nextEvents.length"
                  class="grey--text ml-0 pl-0"
                >
                  Next events
                </v-list-item-title>
                <div
                  v-if="nextEvents.length"
                  class="row"
                >
                  <div class="col-12 p-t-0">
                    <table class="next-events">
                      <tr
                        v-for="e of nextEvents"
                        :key="e.id"
                      >
                        <td>
                          {{ e.asset.name }}
                        </td>
                        <td class="p-l-10">
                          {{ moment(e.start).format('MMM D, HH:mm:ss') }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>

        <div class="row">
          <div class="col-md-12 p-t-0">
            <v-card>
              <!--div
                v-if="!channel.distributionURL"
                class="col-md-12 links"
                style="background-color: #eee"
              >
                <i class="fa fa-link m-r-5 m-l-5" /> Master stream URL:
                <a
                  :href="channel.streamURL"
                  target="_blank"
                >{{ channel.streamURL }}</a>
                <i
                  class="zmdi zmdi-copy m-l-10 pointer"
                  @click="handleCopy(channel.streamURL)"
                />
              </div-->
              <div
                v-if="channel.distributionURL && channel.URLDisplayEnabled"
                class="col-md-12 links"
                style="background-color: #eee"
              >
                <i class="fa fa-link m-r-5 m-l-5" /> Distribution URL:
                <a
                  :href="channel.distributionURL"
                  target="_blank"
                >{{ channel.distributionURL }}</a>
                <i
                  class="zmdi zmdi-copy m-l-10 pointer"
                  @click="handleCopy(channel.distributionURL)"
                />
              </div>
              <!--div
                v-if="channel.streamURLWithAds"
                class="col-md-12 links"
                style="background-color: #eee"
              >
                <i class="fa fa-link m-r-5 m-l-5" /> SSAI enabled stream URL:
                <a
                  :href="channel.streamURLWithAds"
                  target="_blank"
                >
                  {{ channel.streamURLWithAds }}
                </a><i
                  class="zmdi zmdi-copy m-l-10 pointer"
                  @click="handleCopy(channel.streamURLWithAds)"
                />
              </div-->
            </v-card>
          </div>
        </div>

        <div
          v-if="false"
          class="row m-t-10"
        >
          <div class="col-md-12 p-l-20">
            <h3 class="title-5">
              <i class="fas fa-film p-r-5" />
              EPG
            </h3>
          </div>
        </div>
        <div
          v-if="false"
          class="row"
        >
          <div
            v-for="day in days"
            :key="day.start"
            class="col-md-4"
          >
            <v-card>
              <table class="table table-bordered table-sm table-epg">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      colspan="2"
                      :class="{ 'primary--text': day.current }"
                      class="text-center"
                    >
                      {{ moment(day.start * 1000).format('dddd, D MMMM') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(event, i) in day.events"
                    :key="'event'+i"
                    :class="{'current-event': currentEvent && event.id === currentEvent.id}"
                  >
                    <td
                      style="width: 165px !important;"
                      class="p-l-10"
                    >
                      {{ moment(event.start).format('hh:mmA') }} -
                      {{ moment(event.end).format('hh:mmA') }}
                    </td>
                    <td class="p-l-10">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ event.asset.name }}
                          </span>
                        </template>
                        {{ event.asset.name }}
                      </v-tooltip>
                      <v-progress-linear
                        v-if="currentEvent && event.id === currentEvent.id"
                        :value="playedProgress"
                        color="blue lighten-2"
                        class="ma-0 pa-0"
                        height="5"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import moment from 'moment-timezone'
  import { processChannel, processProgram2, processDistribution } from '@/store/converters'
  import { setClipboard } from '@/helpers/utils'
  import videoPlayer from '@/player/player'

  console.log(videoPlayer)

  export default {
    components: {
      videoPlayer,
    },
    metaInfo: {
      title: 'On Air',
    },
    data () {
      return {
        playerOptions: {
          src: '',
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: 'video/mp4',
            src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          }],
          poster: '/static/images/author.jpg',
        },
        channel: {
          id: 0,
          logo: '',
          name: '',
          timezone: {},
          streamURL: '',
          distributionURL: '',
          ssaiURL: '',
          // remove:
          announcementDuration: 0,
          adDuration: 0,
        },
        frameSrc: '',
        hlsFrameSrc: '',
        currentT: null,
        currentTz: null,
        currentEvent: null,
        nextEvents: [],
        tzOffset: 0,
        allEvents: [],
        remaining: '',
        played: '',
        polling: null,
        days: [],
        epgEvents: [],
        currentUnixTime: moment().utc().unix() * 1000,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      playedProgress () {
        if (!this.currentEvent) return 0
        const eventDuration = this.currentEvent.endOriginal - this.currentEvent.startOriginal
        // eslint-disable-next-line no-mixed-operators
        return (this.currentUnixTime - this.currentEvent.startOriginal) * 100 / eventDuration
      },
      defaultPoster () {
        return '/images/ch_icon.png'
      },
    },
    watch: {
      '$route' (to, from) {
        if (to.params.id) {
          this.getChannelInfo(to.params.id)
        }
      },
    },
    mounted () {
      this.updateTime()
      this.updateTimer()
    },
    created () {
      const channelId = this.$route.params.id
      this.channel.id = channelId

      this.getChannelInfo(channelId)

      this.currentT = moment().unix()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      getChannelInfo (id) {
        this.$store.commit('setPageLoader')

        const args = {
          ids: id,
          expand: 'timezone',
        }
        const channelReq = this.$store.dispatch('channels', args)

        const distribReqArgs = {
          'default[eq]': 1,
          'channel.id[eq]': id,
        }
        const distribReq = this.$store.dispatch('distributions', distribReqArgs)

        return Promise.all([channelReq, distribReq])
          .then((res) => {
            const channels = res[0]
            this.channel = processChannel(channels[0])

            // eslint-disable-next-line max-len
            this.tzOffset = moment.tz(moment.tz.guess()).utcOffset() * 60 * 1000 - moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000
            this.currentTz = moment.utc(moment().unix() * 1000 + moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000).format('MMM D, HH:mm:ss')

            let streamURL = this.channel.streamURLhlsv3
            /*          let offset = 1;
          if (this.channel.dvrDuration > 0) {
            offset = Math.ceil(this.channel.dvrDuration / 60);
          } */

            const distributions = res[1]
            if (distributions.length) {
              const processed = processDistribution(distributions[0])
              for (const key in processed.urls) {
                if (key === 'hls3') {
                  this.channel.distributionURL = processed.urls[key]
                  streamURL = processed.urls[key]
                }
              }
            }
            streamURL = streamURL.replace('$origin', 'now')
            streamURL = streamURL.replace('$offset', '-1m_15s')
            streamURL = streamURL.replace(',', '_')
            this.channel.streamURL = streamURL
            this.frameSrc = `/js/radiant/index.html?src=${streamURL}`

            this.playerOptions.src = this.channel.streamURL

            this.getPrograms()
          // this.getEPG();
          })
          .catch((errorMsg) => {
            console.log('error getting channel', errorMsg)
            this.$router.push({ name: 'DashboardPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getEPG () {
        const today = moment.utc(moment().utc().unix() * 1000 + moment.tz(this.channel.tz).utcOffset() * 60 * 1000).startOf('day')
        const yesterday = today.clone().subtract(1, 'days')
        const tomorrow = today.clone().add(1, 'days')
        this.days.push({
          start: moment(`${yesterday.format('YYYY-MM-DD')}T00:00:00Z`).utc().unix() - moment.tz(this.channel.tz).utcOffset() * 60,
          end: moment(`${yesterday.format('YYYY-MM-DD')}T23:59:59Z`).utc().unix() - moment.tz(this.channel.tz).utcOffset() * 60,
        })
        this.days.push({
          start: moment(`${today.format('YYYY-MM-DD')}T00:00:00Z`).utc().unix() - moment.tz(this.channel.tz).utcOffset() * 60,
          end: moment(`${today.format('YYYY-MM-DD')}T23:59:59Z`).utc().unix() - moment.tz(this.channel.tz).utcOffset() * 60,
          current: 1,
        })
        this.days.push({
          start: moment(`${tomorrow.format('YYYY-MM-DD')}T00:00:00Z`).utc().unix() - moment.tz(this.channel.tz).utcOffset() * 60,
          end: moment(`${tomorrow.format('YYYY-MM-DD')}T23:59:59Z`).utc().unix() - moment.tz(this.channel.tz).utcOffset() * 60,
        })

      // this.getEPGPrograms();
      },
      updateTime () {
        this.polling = setInterval(() => {
          this.currentUnixTime = moment().utc().unix() * 1000
          this.currentTz = moment.utc(moment().unix() * 1000 + moment.tz(this.channel.timezone.name).utcOffset() * 60 * 1000).format('MMM D, HH:mm:ss')
          this.findCurrentEvent()
        }, 30 * 1000)
      },
      updateTimer () {
        setInterval(() => {
          const now = Date.now()
          if (this.currentEvent) {
            const remaining = this.currentEvent.endOriginal - now
            const played = now - this.currentEvent.startOriginal
            this.played = played > 0 ? moment.utc(played).format('HH:mm:ss.SSS') : ''
            if (remaining <= 0) {
              this.findCurrentEvent()
            }
            this.remaining = remaining > 0 ? moment.utc(remaining).format('HH:mm:ss.SSS') : ''
          }
        }, 100)
      },
      findCurrentEvent () {
        if (!this.channel.timezone.name) return
        const t = moment().utc().unix() * 1000
        this.currentEvent = null
        for (let j = 0; j < this.allEvents.length; j += 1) {
          const event = this.allEvents[j]
          if (t >= event.startOriginal && t <= event.endOriginal) {
            this.currentEvent = event
            break
          }
        }
        if (!this.currentEvent) {
        // this.toolbarCurrentEvent();
        }
      // this.nextEvents = this.getNextEvents();
      },
      toolbarCurrentEvent () {
        const params = {
          channel_id: this.channel.id,
        }
        this.$store.dispatch('programs/getCurrentProgram', params)
          .then((program) => {
            if (program) {
              this.currentEvent = this.processProgram(program)
            }
          })
          .catch((errorMsg) => {
            // eslint-disable-next-line no-console
            console.log('getCurrentProgram', errorMsg)
          })
      },
      processEvent (p) {
        const program = processProgram2(p)
        const start = moment(program.startTime).utc().unix() * 1000
        const end = moment(program.endTime).utc().unix() * 1000

        return {
          id: program.id,
          color: '#eceff1',
          start: start - this.tzOffset,
          end: end - this.tzOffset,
          startOriginal: start,
          endOriginal: end,
          program,
          fixed: p.fixed,
          timed: true,
          t: true,
        }
      },
      getPrograms () {
        this.$store.commit('setPageLoader')

        const params = {
          'end_time[gt]': `${moment().utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'start_time[lt]': `${moment().add(2, 'days').utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
          'channel.id[eq]': this.channel.id,
          $expand: 'items',
        }
        this.$store.dispatch('programs2', params)
          .then((programs) => {
            this.allEvents = programs.map((p) => this.processEvent(p))
            this.findCurrentEvent()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getEPGPrograms () {
        if (!this.days.length) return

        const params = {
          from: this.days[0].start,
          to: this.days[this.days.length - 1].end,
          channel_id: this.channel.id,
        }
        this.$store.dispatch('programs/getPrograms', params)
          .then((programs) => {
            this.epgEvents = programs.map((p) => this.processProgram(p))
            for (let i = 0; i < this.days.length; i += 1) {
              this.calcDay(this.days[i])
            }
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      calcDay (day) {
        const dayStart = day.start * 1000
        const dayEnd = day.end * 1000

        // eslint-disable-next-line no-param-reassign
        day.events = []

        // eslint-disable-next-line no-nested-ternary,max-len
        this.epgEvents.sort((a, b) => ((a.startOriginal > b.startOriginal) ? 1 : ((b.startOriginal > a.startOriginal) ? -1 : 0)))

        const events = []

        for (let i = 0; i < this.epgEvents.length; i += 1) {
          const event = this.epgEvents[i]
          if ((event.startOriginal > dayStart && event.startOriginal < dayEnd) ||
            (event.endOriginal > dayStart && event.endOriginal < dayEnd)) {
            events.push(event)
          }
        }

        // eslint-disable-next-line no-param-reassign
        day.totalEvents = events.length

        const gapEvents = []
        if (events.length > 0) {
          for (let i = 0; i < events.length; i += 1) {
            const event = events[i]
            if (i !== events.length - 1) {
              if (i === 0 && event.startOriginal - dayStart > 60) {
                gapEvents.push({
                  asset: {
                    name: '---',
                  },
                  start: dayStart - this.tzOffset,
                  end: event.start,
                })
              }
              if (events[i + 1].startOriginal - event.endOriginal > 60) {
                gapEvents.push({
                  asset: {
                    name: '---',
                  },
                  start: event.end,
                  end: events[i + 1].start,
                })
              }
            } else if (dayEnd - event.endOriginal > 60) {
              gapEvents.push({
                asset: {
                  name: '---',
                },
                start: event.end,
                end: dayEnd - this.tzOffset,
              })
            }
          }
        } else {
          gapEvents.push({
            asset: {
              name: '---',
            },
            start: dayStart - this.tzOffset,
            end: dayEnd - this.tzOffset,
          })
        }

        const allEvents = events.concat(gapEvents)
        // eslint-disable-next-line no-nested-ternary
        allEvents.sort((a, b) => ((a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0)))
        // eslint-disable-next-line no-param-reassign
        day.events = allEvents
      },
      getNextEvents () {
        const nextEvents = []
        let currentEvent = {}
        // eslint-disable-next-line no-nested-ternary
        this.allEvents.sort((a, b) => ((a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0)))
        for (let j = 0; j < this.allEvents.length; j += 1) {
          if (this.currentEvent && this.currentEvent.id === this.allEvents[j].id) {
            for (let i = 0; i < 3; i += 1) {
              currentEvent = this.allEvents[j + i]
              if (j + i + 1 < this.allEvents.length) {
                if (this.allEvents[j + i + 1].start > currentEvent.end) {
                  nextEvents.push({
                    asset: {
                      name: '---',
                    },
                    start: currentEvent.end,
                    end: this.allEvents[j + i + 1].start,
                  })
                  if (nextEvents.length === 3) {
                    return nextEvents
                  }
                }
                nextEvents.push(this.allEvents[j + i + 1])
                if (nextEvents.length === 3) {
                  return nextEvents
                }
              } else {
                break
              }
            }
            break
          }
        }
        return nextEvents
      },
      handleCopy (text) {
        setClipboard(text)
        this.$store.commit('showSnackbar', {
          text: 'URL has been copied',
          timeout: 6000,
          color: 'success',
        })
      },
      iconError () {
        this.channel.icon = this.defaultPoster
      },
      playerReadied (player) {
        this.playerOptions.src = '12'
        console.log('the player is readied', player)
        this.playerOptions.src = this.channel.streamURL
        // you can use it to do something...
        // player.[methods]
        const newSourceObject = {
          hls: this.channel.streamURL,
        };
        player.setSrc(newSourceObject);
      },
    },
  }
</script>

<style>
  .next-events {
    width: 100%;
  }
  .next-events td {
    vertical-align: top;
    line-height: normal !important;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  .next-events tr:last-child td {
    border-bottom: 0;
  }
  .next-events td span {
    display: inline;
    float: left;
  }
  .current-event {
    background-color: #E3F2FD;
  }
</style>
